<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="row m-0 g-0">
    <div class="col-md-3 p-0">
      <app-folders></app-folders>
    </div>

    <div class="col-md-9 container" style="border-top-left-radius: 15px; border-top-right-radius: 15px; overflow: hidden; margin-top: 0 !important; margin-left: -7px;">
      <div class="card" style="height: 1000px;">
        <div class="card-body">
          <div class="d-flex justify-content-start" style="margin-top: 0 !important;">
            <button type="button" class="btn custom-button" style="margin-bottom:10px ;"   (click)="goBack()">Back</button>
          </div>
         

                   
<!-- new -->
<div class="new-card"
      style="border: 2px solid #4A148C; border-radius: 12px; padding: 10px 20px;background-color: #ffffff; box-shadow: 0 4px 12px rgba(103, 58, 183, 0.1);margin-bottom: -15px; font-family: 'Segoe UI', sans-serif; ">
  <div class="card-content">
    <div class="row d-flex align-items-center justify-content-between flex-wrap" style="gap: 12px; font-size: 15px; color: #333;">
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Code:</strong> {{ studyCode }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Name:</strong> {{ studyName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Subject Name:</strong> {{ subjectName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Site Location:</strong> {{ siteLocation }}
      </div>
    </div>
  </div>
</div>


            <!-- Rescue Medication Log -->
<div *ngIf="formName === 'rescue-medication-log'" class="card mt-4" >
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="m-0">Rescue Medication Log</h5>
      <!--<button type="button" class="btn custom-button">Create Field</button>-->
    </div>
          
       <!-- Small Modal (Right-side) -->
        <div class="options-modal" *ngIf="isOptionsModalOpen" (click)="$event.stopPropagation()" style="margin-top: 47px; margin-right: 40px;">
  <div class="modal-buttons">
    <button (click)="openModal()">Query</button>
    <button (click)="editStudy()">Edit</button>
    <button (click)="openReviewModal()">Review</button>
  </div>
  </div>
  <div class="modal-overlay" *ngIf="isReasonModalOpen">
  <div class="modal-content">
    <button class="close-btn" (click)="cancelEditReason()">×</button>
    <h4>Please provide a reason for editing:</h4>
    <textarea class="form-control" [(ngModel)]="editReason" rows="4" placeholder="Enter reason here..."></textarea>
    <div class="modal-footer">
      <button class="btn custom-button" (click)="confirmEditReason()">Confirm</button>
      <button class="btn custom-button" (click)="cancelEditReason()">Cancel</button>
    </div>
  </div>
</div>

  
   <!-- Review Modal -->
<div class="modal-overlay1" *ngIf="showReviewModal" (click)="closeReviewModal()">  
  <div class="modal-content1" (click)="$event.stopPropagation()" style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;">
    <!-- Close Button -->
    <span
      class="close-button1"
      (click)="closeReviewModal()">×</span>

    <div class="checkbox-group" style="padding-top: 1.5rem;">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>



        
        <div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content">
     <button class="close-btn" (click)="closeModal()">&times;</button>
     
    <!-- Tab Bar -->
    <div class="tab-bar">
      <div 
        class="tab" 
        *ngFor="let tab of tabs; let idx = index" 
        [class.active]="selectedTab === idx" 
        (click)="selectTab(idx)">
        {{ tab.title }}
        <span class="close-tab" *ngIf="tabs.length > 1" (click)="closeTab(idx, $event)">×</span>
      </div>
      
      <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
       <div *ngIf="tabs[selectedTab].type === 'query'" class="add-btn-wrapper">
          <button class="add-btn" (click)="addQuery(i)">+</button>
          <span class="add-query-tooltip">Add Query</span>
        </div> 
    </div>
   

    <!-- Modal Body -->
    <div class="modal-body">
      <ng-container [ngSwitch]="tabs[selectedTab].type">

        <!-- Query Tab -->
        <div *ngSwitchCase="'query'">
          <div *ngFor="let query of queries; let i = index" class="query-box">
              <!-- Dropdown Field -->
          <select class="form-select mb-2" [(ngModel)]="query.selectedField" [disabled]="query.isClosed">
            <option>Select Column</option>
            <option>Log Line</option>
            <option>Name of the Drug</option>
            <option>Indication</option>
            <option>Start Date</option>
            <option>End Date</option>
            <option>Route of Administration</option>
            <option>Dosage</option>
            <option>Frequency</option>
            <option>Ongoing</option>
          </select>
          <br>
            <div class="input-checkbox-container">
            
              <input
                type="text"
                class="form-control"
                [value]="''"
                (input)="query.text = $event.target.value"
                [readonly]="query.isClosed"
                [ngClass]="{ 'query-closed': query.isClosed }"
                placeholder="Enter your query"
              />



              
             
            </div>
            
            <!-- Audit Trail -->
            <div class="audit-trail">
              <h4>Audit Trail</h4>
              <div class="audit-entry" *ngFor="let entry of query.auditTrail">
                <strong>{{ entry.user }}</strong>- {{ entry.timestamp | date: 'dd-MMM-yyyy h:mm a' }}

                <p>{{ entry.message }}</p>
              </div>
            </div>
            <div class="modal-footer">
      <button class="btn custom-button" (click)="confirmCloseQuery(i)">Close Query</button>
      <button class="btn custom-button ms-2" (click)="confirmSubmitQuery(i)">Submit</button>
      
    </div>
          </div>
        </div>

        <!-- Field History Tab -->
        <div *ngSwitchCase="'fieldHistory'">
          <div *ngIf="fieldHistoryData?.length > 0; else noData">
            <div *ngFor="let entry of fieldHistoryData" class="history-box">
              <div class="history-header">
                <strong>{{ entry.updated_by }}</strong> - {{ entry.updated_at | date: 'medium' }}
              </div>
              <div class="history-value">
                {{ entry.sub_data }}
              </div>
              <!-- ✅ Show edit reason if available -->
      <div class="edit-reason" *ngIf="entry.edit_reason">
        <em>Reason for change: {{ entry.edit_reason }}</em>
      </div>
       <div class="log-label" *ngIf="entry.field_name">
    <small>Field: {{ entry.field_name }}</small>
  </div>
            </div>
          </div>
          <ng-template #noData>
            <p>No history available for this field.</p>
          </ng-template>
        </div>

      </ng-container>
    </div>


    
  </div> 
</div>

    <!-- Table for Rescue Medication Log -->
    <div class="card-body scrollable-container">
      <div class="label-wrapper d-flex align-items-center justify-content-between">
        <button type="button" class="btn custom-button" (click)="addLogLine()" [disabled]="isRescueLogDisabled">Add Log Line</button>
        <div class="menu-icon" (click)="openOptionsModal($event, $event.target)">⋮</div>
      </div>
        <form (ngSubmit)="submitForm()">
        <div class="table-wrapper">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Log Line</th>
                <th>Name of the Drug</th>
                <th>Indication</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Route of Administration</th>
                <th>Dosage</th>
                <th>Frequency</th>
                <th>Ongoing</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngFor="let log of formData.rescueMedicationLogs; let i = index">
                    <td><input type="text" class="form-control" [(ngModel)]="log.logLine" name="logLine{{i}}" [disabled]="isRescueLogDisabled"></td>
                    <td><input type="text" class="form-control" [(ngModel)]="log.drugName" name="drugName{{i}}" [disabled]="isRescueLogDisabled"></td>
                    <td><input type="text" class="form-control" [(ngModel)]="log.indication" name="indication{{i}}" [disabled]="isRescueLogDisabled"></td>
                    <td><input type="date" class="form-control" [(ngModel)]="log.startDate" name="startDate{{i}}" [min]="screeningMinDate" [max]="todayDate" (change)="updateEndDateRange(log)" [disabled]="isRescueLogDisabled"></td>
                    <td><input type="date" class="form-control" [(ngModel)]="log.endDate" name="endDate{{i}}" [min]="log.startDate" [max]="todayDate" [disabled]="isRescueLogDisabled"></td>
                    <td>
                      <select class="form-control" [(ngModel)]="log.route" name="route{{i}}" [disabled]="isRescueLogDisabled">
                        <option value="ORL">Oral</option>
                        <option value="IV">Intravenous</option>
                        <option value="IM">Intramuscular</option>
                        <option value="NEB">Nebulizer</option>
                        <option value="INH">Inhaler</option>
                        <option value="SC">Subcutaneous</option>
                      </select>
                    </td>
                    <td><input type="text" class="form-control" [(ngModel)]="log.dosage" name="dosage{{i}}" [disabled]="isRescueLogDisabled"></td>
                    <td>
                      <select class="form-control" [(ngModel)]="log.frequency" name="frequency{{i}}" [disabled]="isRescueLogDisabled">
                        <option value="OD">Once a day</option>
                        <option value="BD">Twice a day</option>
                        <option value="TID">Thrice a day</option>
                        <option value="QID">Four times a day</option>
                        <option value="SOS">If needed</option>
                      </select>
                    </td>
                    <td>
                      <select class="form-control" [(ngModel)]="log.ongoing" name="ongoing{{i}}" [disabled]="isRescueLogDisabled">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </td>
                  </tr>
              </tbody>
          </table>
        </div>
      
       <div class="text-end">
        <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button>-->
        <button type="submit" class="btn custom-button">Submit</button>
      </div>
      </form>
    </div>
</div>
</div>
</div>
</div>
</div>
</div>
